import { types } from "../action-types";

const initialState = {
    loading: false,
    rating: [],
    ratingSuccess: false,
    ratingFailure: false,
};

const ratingReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.POST_RATING_REQUESTED:
            return {
                ...state,
                loading: true,
                rating: [],
                ratingSuccess: false,
                ratingFailure: false,
            };

        case types.POST_RATING_SUCCESS:
            return {
                ...state,
                loading: false,
                rating: action.payload,
                ratingSuccess: true,
                ratingFailure: false,
            };

        case types.POST_RATING_FAILURE:
            return {
                ...state,
                loading: false,
                rating: [],
                ratingSuccess: false,
                ratingFailure: true,
            };

        case types.PUT_RATING_REQUESTED:
            return {
                ...state,
                loading: true,
                rating: [],
                ratingSuccess: false,
                ratingFailure: false,
            };

        case types.PUT_RATING_SUCCESS:
            return {
                ...state,
                loading: false,
                rating: action.payload,
                ratingSuccess: true,
                ratingFailure: false,
            };

        case types.PUT_RATING_FAILURE:
            return {
                ...state,
                loading: false,
                rating: [],
                ratingSuccess: false,
                ratingFailure: true,
            };
        case types.CLEAR_RATING_CHECK:
            return{
                ...state,
                ratingSuccess: false,
            }
        default:
            return state;
    }
};

export default ratingReducer;
